// extracted by mini-css-extract-plugin
export default {"flex-column":"noImages_flex-column__7uh8L","empty":"noImages_empty__vTk54","flex-row":"noImages_flex-row__n99Zx","page-size":"noImages_page-size__6xbkx"};